export default {
  /**
   * Function execute a promise function with retry logic
   * Referenced from: https://gist.github.com/briancavalier/842626/c0eb8816486a95d907ca1cd754c9f6e17f68d589
   *
   * @param param - The parameters for promise function
   * @param fn - The promise function.
   * @param retriesLeft - The number of retries left.
   * @param interval - The interval before retrying.
   * @returns {Promise}
   */
  retryPromise(param, fn, retriesLeft = 20, interval = 3000) {
    return new Promise((resolve, reject) => {
      return fn(param)
        .then(resolve)
        .catch((error) => {
          if (retriesLeft === 1) {
            // reject('maximum retries exceeded');
            console.log("Retry limit");
            reject(error);
            return;
          }

          setTimeout(() => {
            // Passing on "reject" is the important part
            this.retryPromise(param, fn, retriesLeft - 1, interval).then(resolve, reject);
          }, interval);
        });
    });
  },
};
